module.exports = __webpack_public_path__ + "static/media/material-wool.2538e5ce.svg";